<template>
<div class='index-view'>
  <!-- <quotas-required-dialog ref='quotas-required-dialog' /> -->
  <!-- 顶部公告栏 -->
  <el-alert type="info" class='notice' v-if='!tbcMode && !embedMode' :closable="false" show-icon title=''>
    PP匠2.0版本正式发布，推出会员计划，为用户带来更实用完善的服务，<a class='text-btn' href='/price' target='_blank'>了解详情</a>。
  </el-alert>

  <!-- 分类功能区域 -->
  <category v-if="/^\/categories/.test($route.path) || hasProjects" />

  <!-- 项目列表区域 -->
  <projects-list @has-projects='hasProjects = $event' ref='projects-list' />
</div>
</template>

<script>
// loading sub-components
import Category from './category'
import ProjectsList from './list'

export default {
  data() {
    return {
      hasProjects: false
    }
  },
  components: {
    'category': Category,
    'projects-list': ProjectsList
  },
  beforeRouteUpdate(to, from, next) {
    this.$refs['projects-list'].refreshData()
    next(true)
  }
}
</script>

<style lang='scss' scoped>
.index-view {
    width: $page-width-base - 30px;
    .notice {
        margin-bottom: 20px;
        width: 100%;

        .text-btn {
            color: $color-white-base;
            text-decoration: underline;
        }
    }

    .hint {
        color: $font-color-light;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?8c93e05c